import { FeatureFlagNames } from 'constants/app.constant';
import { isFeatureEnabled } from 'services/feature-flag.service';
/**
 * Single resolver for "should the Spark variant render" (per INS-6400: keep this decision
 * behind one resolver instead of branching on the feature flag inside each component).
 * Product-level gating (INS-6468/INS-6469 — is *this course* a Spark course) isn't required
 * until pilot; until then the flag alone is an accepted proxy. When product gating lands,
 * extend this function only — callers don't change.
 */
export var isSparkVariantEnabled = function (featureFlags) { return isFeatureEnabled(featureFlags, FeatureFlagNames.USPD_SPARK_ENABLED); };
